const normalizePositiveInteger = (value) => {
  if (value == null || String(value).trim() === "") return null;

  const normalized = String(value).trim();
  if (!/^\d+$/.test(normalized)) return null;

  const numericValue = Number(normalized);
  return Number.isSafeInteger(numericValue) && numericValue > 0 ? numericValue : null;
};

export const SETTINGS_EXTRAS_BUSINESS_UNIT_ERRORS = Object.freeze({
  MISSING_ACTIVE: "missing_active",
  INVALID_QUERY: "invalid_query",
  QUERY_MISMATCH: "query_mismatch",
});

export const resolveSettingsExtrasBusinessUnit = ({
  queryBusinessUnitId,
  activeBusinessUnitId,
} = {}) => {
  const activeId = normalizePositiveInteger(activeBusinessUnitId);
  if (!activeId) {
    return {
      businessUnitId: null,
      errorCode: SETTINGS_EXTRAS_BUSINESS_UNIT_ERRORS.MISSING_ACTIVE,
    };
  }

  const hasQueryValue = queryBusinessUnitId != null && String(queryBusinessUnitId).trim() !== "";
  if (!hasQueryValue) {
    return { businessUnitId: activeId, errorCode: null };
  }

  const queryId = normalizePositiveInteger(queryBusinessUnitId);
  if (!queryId) {
    return {
      businessUnitId: null,
      errorCode: SETTINGS_EXTRAS_BUSINESS_UNIT_ERRORS.INVALID_QUERY,
    };
  }

  if (queryId !== activeId) {
    return {
      businessUnitId: null,
      errorCode: SETTINGS_EXTRAS_BUSINESS_UNIT_ERRORS.QUERY_MISMATCH,
    };
  }

  return { businessUnitId: queryId, errorCode: null };
};
